import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/claim/rect.png'


const _withScopeId = n => (_pushScopeId("data-v-2b0de09c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "export-con" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "font_family icon-xiazai",
  style: {"margin-right":"5px"}
}, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Export ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "rect"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "wrap-title" }, " Existing vin with potential change in retail eligibility")
], -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Ignore and submit")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Reject to SICCO")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    class: "check-modal",
    visible: _ctx.checkVisible,
    onCancel: _ctx.close,
    centered: "",
    width: "900px"
  }, {
    title: _withCtx(() => [
      _hoisted_4
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_a_button, {
        style: {"border-color":"#40a9ff","color":"#40a9ff"},
        onClick: _ctx.handleSubmit
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_a_button, {
        type: "primary",
        disabled: _ctx.disabledReject(),
        onClick: _ctx.handleReject
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createVNode(_component_a_button, {
          style: {"color":"black"},
          type: "link",
          onClick: _ctx.handleExport
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createVNode(_component_a_table, {
        columns: _ctx.colums,
        dataSource: _ctx.checkDataSource,
        class: "ant-table-striped",
        scroll: { y: 500, x: 1000 },
        rowKey: _ctx.id,
        "row-selection": _ctx.rowSelection,
        rowClassName: (record, index) => (index % 2 === 1 ? 'table-striped' : null),
        pagination: false
      }, null, 8, ["columns", "dataSource", "rowKey", "row-selection", "rowClassName"])
    ]),
    _: 1
  }, 8, ["visible", "onCancel"]))
}